import { UzButton } from '@utazzo/ui';
import { RefreshCw } from 'lucide-react';
import React from 'react';

import { BookingsList } from '../components/BookingsList';
import { useBackfillGatewayFees } from '../use-travel-bookings';

import { PageShell } from '@/components/page-shell';

/**
 * Ticketing > Flights.
 *
 * Every flight really booked with the airline - confirmed straight through,
 * or confirmed by an admin from the hold queue - and whatever became of it
 * since (cancellation requested, cancelled, refunded). Read-only: the
 * decisions live on Action needed and on the booking itself. Per-booking net
 * profit is a column in the list; the header just carries the fee sync.
 */
export const TicketingFlightsPage = (): React.JSX.Element => {
  const backfillFees = useBackfillGatewayFees();

  return (
    <PageShell
      title="Flights"
      description="Flight bookings made with the airline, including the ones an admin confirmed from the hold queue. Filter by status to see cancellations and refunds."
      actions={
        <UzButton
          variant="ghost"
          size="sm"
          onClick={() => backfillFees.mutate()}
          loading={backfillFees.isPending}
          leftIcon={<RefreshCw className="h-4 w-4" />}
          title="Fetch and record the Razorpay fee on any paid booking still missing it, so net profit is exact."
        >
          Sync gateway fees
        </UzButton>
      }
    >
      <BookingsList gridId="ticketing-flights" variant="booked" product="FLIGHT" />
    </PageShell>
  );
};
